import { Swiper, SwiperSlide } from 'swiper/react';
import React, { useState, useEffect, useContext } from 'react';
import EmptyActivity from '../../components/Common/EmptyActivity/EmptyActivity';
import { WelletContext } from '../../context/WelletContext';
import AccountHeader from '../../components/AccountHeader/AccountHeader';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import EventCardChecker from '../../components/EventsChecker/EventCardChecker';
import { getLocale } from '../../helpers/dates';
import DataManager from '../../context/DataManager';
import { getCookie } from '../../helpers/cookie';
import styles from './AccountChecker.module.css';
import { CircleSpinner } from 'react-spinners-kit';
import { SkeletonFilters } from '../../components/Skeletons/SkeletonVenueList';
import Filter from '../../components/Venues/Filter';
import ChevronIcon from '../../components/icons/chevronIcon';
import NavSelector from '../../components/NavSelector/NavSelector';
import { useTranslation } from 'react-i18next';

const AccountChecker = () => {
  const welletContext = useContext(WelletContext);
  const app = useSelector((state) => state.app);
  const locale = getLocale(app.language);
  const history = useHistory();
  const [eventBanners, setEventBanners] = useState([]);
  const [loadingEvents, setLoadingEvents] = useState(true);
  const [loadingCity, setLoadingCity] = useState(true);
  const { citySelected } = useContext(DataManager);
  const cityCookie = getCookie('defaultCity');
  const { t } = useTranslation();
  const selectedCity = cityCookie
  ? JSON.parse(cityCookie)
  : { id: null, name: t('allFem'), nameLong: '' };
  const [cities, setCities] = useState(null);
  const [city, setCity] = useState(null);
  const [totalImages, setTotalImages] = useState(0);
  const [loadingShows, setLoadingShows] = useState(false);
  const [filters, setFilters] = useState([]);
  const [loadingFilters, setLoadingFilters] = useState(true);
  const language = useSelector((state) => state.app.language);


  useEffect(() => {
    if (!cities) {
      getCities();
    }
  }, []);

  const getCities = async () => {
    try {
      setLoadingCity(true);
      const response = await welletContext.apis.tickets.get('/shows/cities');
      setCities(response.data);
      const defaultCity = response.data[0];
      if (citySelected) {
        setCity(response.data.find((c) => c.id === citySelected));
      } else if (cityCookie !== null && cityCookie?.trim() !== '') {
        const cookieCity = response.data.find((c) => c.id === Number(cityCookie));
        setCity(cookieCity ? cookieCity : defaultCity);
      } else {
        setCity(defaultCity);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoadingCity(false);
    }
  };

  useEffect(() => {
    if (city !== null) {
      fetchEventBanners(null);
      getFilters();
    }
  }, [city]);

  const getFilters = async () => {
    try {
      const result = await welletContext.apis.tickets.get(
        `/shows/categories?cityId=${selectedCity.id}&lang=${language}`,
      );
      setFilters(result.data);
    } catch (e) {
      console.error(e);
    } finally {
      setLoadingFilters(false);
    }
  };

  const fetchEventBanners = async (categoryId) => {
    setLoadingEvents(true);
    try {
      const result = await welletContext.apis.tickets.get('/shows/upcoming/events', {
        params: {
          skip: 0,
          take: 10,
          lang: language,
          cityId: selectedCity.id,
          categoryId,
        },
      });

      if (result.data?.errorCode === 'EVENT_NOT_FOUND') {
        setEventBanners([]);
        return;
      }
      setEventBanners(result.data);
      setTotalImages(0);
    } catch (error) {
      console.error(error);
      setEventBanners([]);
    } finally {
      setLoadingEvents(false);
    }
  };

  const onFilterChange = (filter) => {
    setLoadingEvents(true);

    const categoryId = filter ? filter.id : null;
    fetchEventBanners(categoryId);
  };
  const onEventClick = (event) => {
    history.push({
      pathname: `/check-show/${event.id}`,
    });
  };
  const handleLoadImage = () => {
    setTotalImages((prevTotal) => {
      const newTotal = prevTotal + 1;
      if (eventBanners && newTotal === eventBanners.length) {
        setLoadingShows(false);
      }
      return newTotal;
    });
  };

  return (
    <>
      <div>
        <AccountHeader
          title={
            <div
              className={`fw-semibold font-medium ${styles.cityContainer}`}
              onClick={() => history.push('/city-selector')}
            >
              {selectedCity?.name}<ChevronIcon size='15' color='#fff' rotation={90} />
            </div>
          }
          icon='config'
          pathName='/configuration'
        />
      </div>

      <div className='env-bottom env-top'>
        {loadingFilters ? (
          <div className='ml-3 mt-4'>
            <SkeletonFilters />
          </div>
        ) : (
          <>
            <div className={`${styles.highlight} ml-3 mt-4 fade-up`}>
              <div className='mt-3'>
                <Filter filters={filters} onFilterChange={onFilterChange} />
              </div>
            </div>
          </>
        )}
        {loadingEvents ? (
          <div className='loaderDiv'>
            <CircleSpinner
              className='spinner-app mx-auto'
              style={{ margin: 'auto' }}
              size={40}
              color='var(--color-font-primary)'
            />
          </div>
        ) : eventBanners.length > 0 ? (
          eventBanners.map((show) => (
            <div
              key={show.showId}
              style={{ marginLeft: '15px', marginBottom: '15px', marginTop: '15px' }}
            >
              <div
                style={{
                  fontSize: '20px',
                  fontWeight: '600',
                  marginBottom: '10px',
                  marginTop: '30px',
                }}
              >
                {show.showName}
              </div>
              <Swiper slidesPerView={'auto'} effect='slide' touchRatio={1.2}>
                {show.events.map((event) => (
                  <SwiperSlide key={event.id}>
                    <div
                      style={{
                        overflow: 'hidden',
                        marginRight: '10px',
                        boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                      }}
                    >
                      <EventCardChecker
                        title={event.name}
                        locale={locale}
                        id={event.id}
                        startDate={event.startDate}
                        image={event.bannerImage}
                        onHandleClick={() => onEventClick(event)}
                        handleLoadImage={handleLoadImage}
                      />
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          ))
        ) : (
          <div className='mt-3 m-2'>
            <EmptyActivity title={t('weAreSorry')} subtitle={t('currentlyNoEventsInThisSection')} />
          </div>
        )}
      </div>

      <NavSelector history={history} isDisabled={true} />
    </>
  );
};

export default AccountChecker;
